const getRedirectOrigin = () => {
  const origin = window.location.origin;
  if (origin.includes('localhost') && origin.startsWith('http://')) {
    return origin;
  }
  return origin.replace('http://', 'https://');
};

export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || undefined,
  redirectUri: `${getRedirectOrigin()}/auth/callback`,
  scope: 'openid profile email',
  useRefreshTokens: true,
  cacheLocation: 'localstorage' as const,
};
